module.exports = __webpack_public_path__ + "img/500.6e141c04.jpg";